import React from 'react';
import PropTypes from 'prop-types';
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';
import { formatNumber } from 'helper';

function Pagination({ value, onChange, withPage }) {
  const handlePrev = () => {
    const newPage = value.current_page - 1;
    if (newPage <= 0) return;
    onChange((state) => ({ ...state, page: newPage }));
  };

  const handleNext = () => {
    const newPage = value.current_page + 1;
    if (newPage > value.last_page) return;
    onChange((state) => ({ ...state, page: newPage }));
  };

  // eslint-disable-next-line
  if (+value?.last_page === 1) return null;

  return (
    <div className="flex items-center justify-between">
      <div className="flex w-full items-center justify-between">
        {withPage && (
          <div>
            <p className="text-sm text-gray-700">
              <span className="font-medium">
                {formatNumber(value?.last_page || '1', 0)}
              </span>{' '}
              page(s)
            </p>
          </div>
        )}
        <div>
          <nav
            className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
            aria-label="Pagination"
          >
            <button
              type="button"
              onClick={handlePrev}
              className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            >
              <span className="sr-only">Previous</span>
              <HiOutlineChevronLeft className="h-5 w-5" aria-hidden="true" />
            </button>
            <button
              type="button"
              disabled
              className="relative inline-flex items-center px-4 py-2 border bg-white border-gray-300 text-sm font-medium"
            >
              <span>{formatNumber(value?.current_page || '1', 0)}</span>
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            >
              <span className="sr-only">Next</span>
              <HiOutlineChevronRight className="h-5 w-5" aria-hidden="true" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}

Pagination.propTypes = {
  value: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  withPage: PropTypes.bool,
};

Pagination.defaultProps = {
  onChange: () => {},
  value: {
    current_page: 1,
    last_page: 1,
    total: 1,
  },
  withPage: true,
};

export default Pagination;
